import React, { useEffect, useState } from 'react';
import { Link, Outlet, useLocation } from 'react-router-dom';
import { FiPlusCircle, FiList, FiFileText, FiZap, FiSettings, FiPlayCircle } from 'react-icons/fi';
import AdminLayout from './AdminLayout';
import usePermissions from '../../rbac/usePermissions';
import SectionContext from './SectionContext';

const sections = {
    categories: { title: 'Рубрики', base: '/categories' },
    authors: { title: 'Авторы', base: '/authors' },
    candidates: { title: 'Кандидаты для обзора', base: '/candidates' },
    research: { title: 'Исследования сайтов', base: '/research' },
    articles: { title: 'Статьи', base: '/articles' },
    media: { title: 'Медиатека', base: '/media' },
    clients: { title: 'Клиенты', base: '/clients' },
};

const SectionPage = ({ section }) => {
    const { can } = usePermissions();
    const { pathname } = useLocation();
    const { title, base } = sections[section];
    const [cards, setCards] = useState({});
    const [dirty, setDirty] = useState(false);
    const automation = pathname.startsWith('/automation');
    const root = automation ? '/automation' : base;
    const suffix = pathname.slice(root.length + 1);
    const card = suffix && !['create', 'settings', 'card', 'publication-plan', 'prompts'].includes(suffix);
    useEffect(() => {
        if (card) setCards(current => ({ ...current, [root]: pathname }));
    }, [card, root, pathname]);
    const cardPath = cards[base] || `${base}/card`;
    const tabs = [
        { label: section === 'media' ? 'Загрузка' : 'Создание', to: section === 'candidates' ? `${base}/settings` : `${base}/create`, permission: section === 'candidates' ? 'candidates:settings' : `${section}:create`, icon: FiPlusCircle, active: !automation && suffix === (section === 'candidates' ? 'settings' : 'create') },
        { label: 'Список', to: base, permission: `${section}:list`, icon: FiList, active: pathname === base },
        { label: 'Карточка', to: cardPath, permission: `${section}:read`, icon: FiFileText, active: !automation && (card || suffix === 'card') },
    ];
    if (section === 'articles') tabs.push(
        { label: '\u041f\u043b\u0430\u043d \u043f\u0443\u0431\u043b\u0438\u043a\u0430\u0446\u0438\u0439', to: '/articles/publication-plan', permission: 'articles:read', icon: FiList, active: pathname === '/articles/publication-plan' },
        { label: 'Автоматизация', to: '/automation', permission: 'automation:read', icon: FiZap, active: pathname === '/automation' },
        { label: 'Подготовка статей', to: '/automation/create', permission: 'automation:create', icon: FiPlayCircle, active: pathname === '/automation/create' },
        { label: 'Настройки автоматизации', to: '/automation/settings', permission: 'automation:settings', icon: FiSettings, active: pathname === '/automation/settings' },
        { label: 'Промпты', to: '/automation/prompts', permission: 'automation:read', icon: FiFileText, active: pathname === '/automation/prompts' },
        { label: 'Карточка задания', to: cards['/automation'] || '/automation/card', permission: 'automation:read', icon: FiFileText, active: automation && (card || suffix === 'card') },
    );
    const guardNavigation = event => {
        const link = event.target.closest('a[href]');
        if (!dirty || !link || new URL(link.href).pathname === pathname || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
        if (!window.confirm('Перейти в другой таб? Несохранённые изменения будут потеряны.')) {
            event.preventDefault(); event.stopPropagation();
        }
    };
    return <AdminLayout><div onClickCapture={guardNavigation} className="space-y-5">
        <header className="overflow-hidden rounded-lg border border-admin-line bg-admin-surface">
            <h1 className="px-5 py-5 text-2xl font-semibold text-admin-heading md:px-6">{title}</h1>
            <nav aria-label={`Табы раздела ${title}`} className="admin-tabs flex flex-wrap border-t border-admin-line bg-admin-soft/40 px-2 md:px-3">
                {tabs.filter(tab => can(tab.permission)).map(({ label, to, icon: Icon, active }) => <Link key={label} to={to} aria-current={active ? 'page' : undefined} className={`flex items-center gap-2 border-b-2 px-3 py-4 text-sm transition focus-visible:outline focus-visible:outline-2 focus-visible:outline-admin-primary ${active ? 'border-admin-primary font-medium text-admin-primary' : 'border-transparent text-admin-muted hover:bg-admin-soft hover:text-admin-heading'}`}><Icon className="shrink-0" aria-hidden="true" />{label}</Link>)}
            </nav>
        </header>
        <SectionContext.Provider value={setDirty}><Outlet /></SectionContext.Provider>
    </div></AdminLayout>;
};

export const EmptySectionCard = ({ base, label = 'запись' }) => <AdminLayout><section className="rounded-lg border border-admin-line bg-admin-surface p-6"><h2 className="mb-3 text-xl">Карточка</h2><p className="mb-4 text-admin-muted">Выберите {label} в списке, чтобы открыть карточку. Здесь будет доступна последняя открытая карточка этого раздела.</p><Link className="entity-primary inline-block" to={base}>Открыть список</Link></section></AdminLayout>;

export default SectionPage;
